export default function formatNumber(number) {
  if (number === "NaN") return "...";
  return Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: 2,
  }).format(Number(number));
}
